import axios from '@/resources/libs/axios'

export default {
    listByCountry(countryId) {
        return axios.get(`/gei/auxiliaries/provinces-countries/provinces/list/all/${countryId}`)
    },
    getAllDistinctAutonomousCommunity() {
        return axios.get(`/gei/children-installation/getAllDistinctAutonomousCommunity`)
    },
    listCountries() {
        return axios.get(`/gei/auxiliaries/provinces-countries/countries/list/all`)
    },
}